<style>
    .ag-theme-material .ag-cell {
        line-height: 35px !important;
    }
</style>

<template>
    <div>
        <vx-card class="p-4 mb-6">
            <div class="flex flex-wrap items-center justify-between mb-10">
                <div class="flex items-center">
                    <h4 style="margin-left: 10px">Inventory</h4>
                </div>
                <div class="flex items-center">
                    <vs-button
                        @click="refreshData"
                        class="btn mb-4 md:mb-0 mr-1"
                        icon="refresh"
                    >Refresh</vs-button>
                    <vs-button
                        class="mb-4 md:mb-0 mr-1"
                        icon="filter_list"
                        @click="filterInit"
                    >Filter</vs-button>
                    <vs-button
                        @click="exportData"
                        class="btn mb-4 md:mb-0 mr-1"
                        icon="import_export"
                    >Export</vs-button>
                </div>
            </div>
            <ag-grid-vue
                :gridOptions="gridOptions"
                class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="columnDefs"
                :defaultColDef="defaultColDef"
                :rowData="inventories"
                colResizeDefault="shift"
                :animateRows="false"
                :floatingFilter="false"
            ></ag-grid-vue>
            <p class="text-right">
                <b>Showing {{ dataFrom }} to {{ dataTo }} of {{ dataTotal }} total entries</b>
            </p>
            <vs-pagination :total="totalPage" v-model="currentPage"></vs-pagination>
        </vx-card>
        <vs-prompt @accept="filterData" title="Filter" :active.sync="showFilter">
            <div class="con-exemple-prompt">
                <label class="vs-input--label">Client</label>
                <vs-select
                    class="selectExample mb-2"
                    v-model="filter.client_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, filter.client)"
                >
                    <vs-select-item v-for="(item, index) in filter.client.data" :key="index" :value="item.id" :text="item.client_code"/>
                </vs-select>
             
                <label class="vs-input--label">Product ID</label>
                <vs-select
                    class="selectExample mb-2"
                    v-model="filter.product_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, filter.product)"
                >
                    <vs-select-item v-for="(item, index) in filter.product.data" :key="index" :value="item.id" :text="item.product_code"/>
                </vs-select>
                <vs-input
                    label="Description"
                    v-model="filter.description"
                    class="mb-2 w-full"
                />
                <vs-input label="Pack ID" v-model="filter.pack_id" class="mb-2 w-full" />
                <vs-input label="Batch" v-model="filter.batch" class="mb-2 w-full" />
                <label class="vs-input--label">Stock Type</label>
                <vs-select
                    class="selectExample mb-2"
                    v-model="filter.stock_type_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, filter.stock_type)"
                >
                    <vs-select-item v-for="(item, index) in filter.stock_type.data" :key="index" :value="item.id" :text="item.name"/>
                </vs-select>
            </div>
        </vs-prompt>
    </div>
</template>

<script>
import vSelect from "vue-select";
import FileSaver from "file-saver";
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";

export default {
    components: {
        vSelect,
        AgGridVue
    },
    data() {
        return {
            searchQuery: "",
            gridOptions: {},
            inventories: [],
            maxPageNumbers: 7,
            gridApi: null,
            isLoading: false,
            columnApi: null,
            showFilter: false,
            columnDefs: null,
            defaultColDef: {
                sortable: true,
                editable: false,
                resizable: true,
                suppressMenu: true
            },
            filter: {
                fetchCount: 0,
                client: {
                    data: [],
                    loading: false,
                    endpoint: 'master/clients',
                    objectKey: 'client_code'
                },
                product: {
                    data: [],
                    loading: false,
                    endpoint: 'master/product',
                    objectKey: 'product_code'
                },
                stock_type: {
                    data: [],
                    loading: false,
                    endpoint: 'master/stocktypes',
                    objectKey: 'name'
                },
                client_id: this.$store.state.user.userconfig.clients ? this.$store.state.user.userconfig.clients.id : null,
                warehouse_id: null,
                location_type_id: null,
                location_id: null,
                document_id: '',
                product_id: null,
                description: '',
                pack_id: '',
                batch: '',
                stock_type_id: null
            },
            totalPage: 0,
            currentPage: 1,
            dataFrom: 0,
            dataTo: 0,
            dataTotal: 0
        };
    },
    watch: {
        isLoading: function() {
            if (this.isLoading) {
                this.$vs.loading();
            } else {
                this.$vs.loading.close();
            }
        },
        currentPage: function() {
            this.fetchData();
        }
    },
    methods: {
        refreshData() {
            this.fetchData();
        },
        fetchData() {
            const filterData = {
                client_id: this.filter.client_id,
                warehouse_id: this.filter.warehouse_id,
                location_type_id: this.filter.location_type_id,
                location_id: this.filter.location_id,
                document_id: this.filter.document_id,
                product_id: this.filter.product_id,
                description: this.filter.description,
                pack_id: this.filter.pack_id,
                batch: this.filter.batch,
                stock_type_id: this.filter.stock_type_id,
            };

            this.isLoading = true;
            Promise.all([
                this.$http.post(
                    "inventories/inventorieslist?page=" + this.currentPage,
                    filterData
                ),
                this.$http.post("unlock_all")
            ])
                .then(
                    this.$http.spread(res => {
                        this.isLoading = false;
                        this.inventories = res.data.data;
                        this.totalPage = res.data.last_page;
                        this.dataTotal = res.data.total;
                        this.dataFrom = res.data.from;
                        this.dataTo = res.data.to;
                    })
                )
                .catch(() => {
                    this.isLoading = false;
                    this.$vs.dialog({
                        type: "confirm",
                        color: "danger",
                        title: "Server Error",
                        text: "Try again?",
                        accept: () => {
                            this.refreshData();
                        },
                        acceptText: "Yes",
                        cancelText: "No"
                    });
                });
        },
        filterInit() {
            if(this.filter.fetchCount < 1) {
                this.isLoading = true
                this.fetchDropdowns()
                .then(() => {
                    this.showFilter = true
                    this.isLoading = false
                    this.filter.fetchCount++
                })
                .catch(error => {
                    this.isLoading = false
                    this.$vs.dialog({
                        type: 'confirm',
                        color: 'danger',
                        title: 'Server Error',
                        text: 'Try again?',
                        accept: () => {
                            this.filterInit()
                        },
                        acceptText: 'Yes',
                        cancelText: 'No'
                    });
                })
            }
            else {
                this.showFilter = true
            }
        },
        filterData() {
            this.fetchData();
        },
        searchClient() {},
        exportData() {
            this.isLoading = true;

             const filterData = {
                client_id: this.filter.client_id,
                warehouse_id: this.filter.warehouse_id,
                location_type_id: this.filter.location_type_id,
                location_id: this.filter.location_id,
                document_id: this.filter.document_id,
                product_id: this.filter.product_id,
                description: this.filter.description,
                pack_id: this.filter.pack_id,
                batch: this.filter.batch,
                stock_type_id: this.filter.stock_type_id,
            };

            this.$http
                .post("inventories/inventorieslist/report/download_excel", filterData, {
                    responseType: "blob"
                })
                .then(res => {
                    this.isLoading = false;
                    FileSaver.saveAs(res.data, "inventory_export.xlsx");
                });
            // .then(response => response.blob())
            // .then(blob => {
            // saveAs(blob, 'inbound_export.xlsx')
        },
        fetchDropdowns() {
            return Promise.all([
                this.$http.post('master/stocktypes'),
                this.$http.post('master/clients'),
                this.$http.post('master/product'),
            ])
            .then(this.$http.spread((stocktypes, clients, products) => {
                this.filter.stock_type.data = stocktypes.data.data
                this.filter.client.data = clients.data.data
                this.filter.product.data = products.data.data

                this.filter.stock_type.data.unshift({id: null, name: 'Any'})
                // this.filter.client.data.unshift({id: null, client_code: 'Any'})
                this.filter.product.data.unshift({id: null, product_code: 'Any'})
            }))
        }
    },
    mounted() {
        this.fetchData()

        this.gridApi = this.gridOptions.api;
        this.gridColumnApi = this.gridOptions.columnApi;
    },
    beforeMount() {
        this.columnDefs = [
            {
                headerName: "Client ID",
                field: "client_code",
                width: 100
                // checkboxSelection: true,
                // headerCheckboxSelectionFilteredOnly: true,
                // headerCheckboxSelection: true,
            },
          
            {
                headerName: "Product ID",
                field: "product_code",
                width: 130
            },
            {
                headerName: "Description",
                field: "product_description",
                width: 130
            },
            {
                headerName: "Pack ID",
                field: "pack_id",
                width: 100
            },
            {
                headerName: "Batch",
                field: "batch",
                width: 100
            },
            {
                headerName: "Exp. Date",
                field: "expired_date",
                width: 100
            },
            {
                headerName: "Base Qty",
                field: "base_qty",
                width: 100
            },
            {
                headerName: "Base UoM",
                field: "base_uom_name",
                width: 100
            },
            {
                headerName: "Stock Type",
                field: "stock_type_name",
                width: 100
            },
            {
                headerName: "Posting Date",
                field: "posting_date",
                width: 100
            },
           
        ];

        this.gridOptions.getRowHeight = function(params) {
            return 35;
        }
    }
};
</script>